import Navbar from '../components/Navbar';
import Footer from 'components/Footer';
import { useSelector } from "react-redux";
import MobileNavbar from 'components/MobileNavbar';
import MobileFooter from 'components/MobileFooter';

import Membership from 'components/BKantarciService/Membership';
import { useEffect } from "react";

function ServiceMembership() {

  const isMobile = useSelector(state => state.windowSize.isMobile);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return (
    <>
    {isMobile ? (
      <>
        <MobileNavbar />
        <Membership />
        <hr />
        <MobileFooter />
      </>
    ) : (
      <>
        <Navbar />
        <Membership />
        <hr />
        <Footer />
      </>
    )}
    </>
  );
}

export default ServiceMembership;
